/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Updated to work with ringV7.glb structure with custom materials
*/

import React, { useMemo } from 'react'
import * as THREE from 'three'
import { useGLTF, MeshRefractionMaterial } from '@react-three/drei'

export function Ring({ frame, diamonds, env, ...props }) {
  const { nodes } = useGLTF('/ringV7.glb')

  const mainDiamondMaterial = useMemo(
    () => ({
      aberrationStrength: 0.015,
      color: diamonds,
      envMap: env,
      side: THREE.DoubleSide,
      toneMapped: false,
    }),
    [diamonds, env]
  )

  const accentDiamondMaterial = useMemo(
    () => ({
      aberrationStrength: 0.02,
      color: diamonds,
      envMap: env,
      side: THREE.DoubleSide,
      toneMapped: false,
    }),
    [diamonds, env]
  )

  const metalMaterial = useMemo(
    () => ({
      color: frame,
      roughness: 0.15,
      metalness: 1,
      envMap: env,
      envMapIntensity: 1.5,
    }),
    [frame, env]
  )

  return (
    <group {...props} dispose={null}>
      {/* Metal Parts Group */}
      <group position={[0, 0, -0.029]}>
        {/* DiamondHolder with nested children */}
        {nodes.DiamondHolder && (
          <mesh 
            castShadow 
            geometry={nodes.DiamondHolder.geometry}
            rotation={[Math.PI / 2, 0, 0]}
          >
            <meshStandardMaterial {...metalMaterial} />
            {nodes.Obj_000006 && <mesh castShadow geometry={nodes.Obj_000006.geometry}><meshStandardMaterial {...metalMaterial} /></mesh>}
            {nodes.Obj_000007 && <mesh castShadow geometry={nodes.Obj_000007.geometry}><meshStandardMaterial {...metalMaterial} /></mesh>}
            {nodes.Obj_000008 && <mesh castShadow geometry={nodes.Obj_000008.geometry}><meshStandardMaterial {...metalMaterial} /></mesh>}
            {nodes.Obj_000044 && <mesh castShadow geometry={nodes.Obj_000044.geometry}><meshStandardMaterial {...metalMaterial} /></mesh>}
          </mesh>
        )}

        {/* All Bezels */}
        {nodes.Bezel_015 && <mesh castShadow geometry={nodes.Bezel_015.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Bezel_016 && <mesh castShadow geometry={nodes.Bezel_016.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Bezel_017 && <mesh castShadow geometry={nodes.Bezel_017.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Bezel_018 && <mesh castShadow geometry={nodes.Bezel_018.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Bezel_019 && <mesh castShadow geometry={nodes.Bezel_019.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Bezel_020 && <mesh castShadow geometry={nodes.Bezel_020.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Bezel_021 && <mesh castShadow geometry={nodes.Bezel_021.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Bezel_022 && <mesh castShadow geometry={nodes.Bezel_022.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Bezel_024 && <mesh castShadow geometry={nodes.Bezel_024.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}

        {/* All Prongs */}
        {nodes.Prong_010 && <mesh castShadow geometry={nodes.Prong_010.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Prong_011 && <mesh castShadow geometry={nodes.Prong_011.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Prong_012 && <mesh castShadow geometry={nodes.Prong_012.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Prong_013 && <mesh castShadow geometry={nodes.Prong_013.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Prong_014 && <mesh castShadow geometry={nodes.Prong_014.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Prong_025 && <mesh castShadow geometry={nodes.Prong_025.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Prong_026 && <mesh castShadow geometry={nodes.Prong_026.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Prong_027 && <mesh castShadow geometry={nodes.Prong_027.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Prong_028 && <mesh castShadow geometry={nodes.Prong_028.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Prong_029 && <mesh castShadow geometry={nodes.Prong_029.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Prong_030 && <mesh castShadow geometry={nodes.Prong_030.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Prong_031 && <mesh castShadow geometry={nodes.Prong_031.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Prong_032 && <mesh castShadow geometry={nodes.Prong_032.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Prong_033 && <mesh castShadow geometry={nodes.Prong_033.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Prong_034 && <mesh castShadow geometry={nodes.Prong_034.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Prong_035 && <mesh castShadow geometry={nodes.Prong_035.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Prong_036 && <mesh castShadow geometry={nodes.Prong_036.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Prong_037 && <mesh castShadow geometry={nodes.Prong_037.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Prong_038 && <mesh castShadow geometry={nodes.Prong_038.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
        {nodes.Prong_039 && <mesh castShadow geometry={nodes.Prong_039.geometry} rotation={[Math.PI / 2, 0, 0]}><meshStandardMaterial {...metalMaterial} /></mesh>}
      </group>

      {/* Diamonds Group - completely separate from metal */}
      <group position={[0, 0, -0.029]}>
        {/* Main/Big Diamond */}
        {nodes.Diamond_Big && (
          <mesh castShadow geometry={nodes.Diamond_Big.geometry} rotation={[Math.PI / 2, 0, 0]}>
            <MeshRefractionMaterial {...mainDiamondMaterial} />
          </mesh>
        )}
        
        {/* Accent Diamonds */}
        {nodes.d1 && <mesh castShadow geometry={nodes.d1.geometry} rotation={[Math.PI / 2, 0, 0]}><MeshRefractionMaterial {...accentDiamondMaterial} /></mesh>}
        {nodes.d2 && <mesh castShadow geometry={nodes.d2.geometry} rotation={[Math.PI / 2, 0, 0]}><MeshRefractionMaterial {...accentDiamondMaterial} /></mesh>}
        {nodes.d3 && <mesh castShadow geometry={nodes.d3.geometry} position={[-6.581, 7.428, -0.054]} rotation={[Math.PI / 2, -0.319, 0]}><MeshRefractionMaterial {...accentDiamondMaterial} /></mesh>}
        {nodes.d4 && <mesh castShadow geometry={nodes.d4.geometry} position={[-4.114, 8.986, 0.049]} rotation={[Math.PI / 2, -0.603, 0]}><MeshRefractionMaterial {...accentDiamondMaterial} /></mesh>}
        {nodes.d5 && <mesh castShadow geometry={nodes.d5.geometry} rotation={[Math.PI / 2, 0, 0]}><MeshRefractionMaterial {...accentDiamondMaterial} /></mesh>}
        {nodes.d6 && <mesh castShadow geometry={nodes.d6.geometry} rotation={[Math.PI / 2, 0, 0]}><MeshRefractionMaterial {...accentDiamondMaterial} /></mesh>}
        {nodes.d7 && <mesh castShadow geometry={nodes.d7.geometry} position={[8.37, 5.285, 0.048]} rotation={[Math.PI / 2, -0.303, 0]}><MeshRefractionMaterial {...accentDiamondMaterial} /></mesh>}
        {nodes.d8 && <mesh castShadow geometry={nodes.d8.geometry} position={[9.621, 2.426, 0.084]} rotation={[Math.PI / 2, -0.602, 0]}><MeshRefractionMaterial {...accentDiamondMaterial} /></mesh>}
      </group>

      {/* Ring Bottom Half */}
      {nodes.RingBottomHalf && (
        <mesh 
          castShadow 
          geometry={nodes.RingBottomHalf.geometry} 
          position={[0, 0, 0.029]} 
          rotation={[Math.PI / 2, 0, 0]} 
          scale={0.967}
        >
          <meshStandardMaterial {...metalMaterial} />
        </mesh>
      )}
    </group>
  )
}

useGLTF.preload('/ringV7.glb')
